import { render, staticRenderFns } from "./readClauseModal.vue?vue&type=template&id=670d8edd"
import script from "./readClauseModal.vue?vue&type=script&lang=js"
export * from "./readClauseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('670d8edd')) {
      api.createRecord('670d8edd', component.options)
    } else {
      api.reload('670d8edd', component.options)
    }
    module.hot.accept("./readClauseModal.vue?vue&type=template&id=670d8edd", function () {
      api.rerender('670d8edd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/groupOrderManage/batchInsurance/components/readClauseModal.vue"
export default component.exports